function clickToToggleLabel(t, open) {
  return open ? t("collapsible-click-to-close", void 0, "(click to close)") : t("collapsible-click-to-open", void 0, "(click to open)");
}
export {
  clickToToggleLabel as c
};
